module.exports = __webpack_public_path__ + "img/banner-1-m.a4a6285c.jpg";